import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { MapPinIcon } from 'lucide-react';
import type { Aop, Territory } from '../../types/dashboard';
import { aopZips } from '../../utils/territory';
import { AOP_PALETTE } from '../../utils/theme';
import { Panel } from '../ui/Panel';
export function AopZipPanel({
  territory,
  selectedAop
}: {
  territory: Territory;
  selectedAop?: Aop;
}) {
  const navigate = useNavigate();
  const {
    search
  } = useLocation();
  const listAops = selectedAop ? [selectedAop] : territory.aops;
  return <Panel title={selectedAop ? `${selectedAop.name} ZIP codes` : 'AOP ZIP codes'} subtitle="An AOP is the 10–15 minute drive time around a venue where a program is marketed, defined by ZIP codes in i9 Sports Connect" data-id="element-542" data-mp="673bb546naez">
      <div className="grid grid-cols-2 gap-2 rounded-md bg-canvas p-2.5" role="img" aria-label="Schematic map of AOP ZIP code clusters" data-id="element-543" data-mp="1vjoqa19ajwy9">
        {territory.aops.map((a, idx) => {
        const color = AOP_PALETTE[idx % AOP_PALETTE.length];
        const dim = selectedAop && selectedAop.id !== a.id;
        return <button key={a.id} type="button" onClick={() => navigate(`/territory/${territory.id}/aop/${a.id}${search}`)} className={`rounded-md border bg-white p-2 text-left transition-opacity duration-150 hover:opacity-100 ${dim ? 'border-line opacity-45' : 'border-line-strong'} ${territory.aops.length === 3 && idx === 2 ? 'col-span-2' : ''}`} data-id="element-544" data-mp="1r3nh2dxxoeb" data-mpi={idx}>
              <div className="mb-1.5 flex items-center gap-1 text-[11px] font-semibold text-ink" data-id="element-545" data-mp="3f7jfy1o0q4sg">
                <MapPinIcon className="h-3 w-3" style={{
              color
            }} data-id="element-546" data-mp="3k4jrut7ju1rh" />
                {a.name}
              </div>
              <div className="flex flex-wrap gap-1" data-id="element-547" data-mp="3oyxot01v0gy9">
                {aopZips(a).map(z => <span key={z} className="h-4 w-6 rounded-[2px]" style={{
              background: color,
              opacity: 0.25 + Number(z) % 7 / 7 * 0.6
            }} title={z} data-id="element-548" data-mp="2rh74whxh7rxn" />)}
              </div>
            </button>;
      })}
      </div>
      <p className="mt-1.5 text-[11px] text-ink-subtle" data-id="element-549" data-mp="2jhau7h3i43nl">Schematic view, not to geographic scale. Tile shade has no data meaning.</p>
      <div className="mt-4 space-y-3" data-id="element-550" data-mp="2y4ce7qyzp8fw">
        {listAops.map(a => <div key={a.id} data-id="element-551" data-mp="2t615xkocf5zs">
            <div className="flex items-baseline justify-between text-xs" data-id="element-552" data-mp="2t7vo4r88ck06">
              <span className="font-semibold text-ink" data-id="element-553" data-mp="25g6sb0w79deh">{a.name}</span>
              <span className="text-ink-subtle" data-id="element-554" data-mp="20hwwqp6kcasc">{a.venue}</span>
            </div>
            <div className="mt-1.5 flex flex-wrap gap-1" data-id="element-555" data-mp="20jzxo4997obu">
              {aopZips(a).map(z => <span key={z} className="rounded border border-line bg-white px-1.5 py-0.5 text-[11px] tabular-nums text-ink-muted" data-id="element-556" data-mp="2fd32rc5ns9lo">{z}</span>)}
            </div>
          </div>)}
      </div>
    </Panel>;
}